import React from "react";
import Chevron from "../../assets/images/common/chevron-right.svg";
import { Link } from "react-router-dom";
import "../../assets/css/blooddonation.scss";
const BreadCrum = ({
  firstText,
  firstLink,
  firstLinkState,
  secondLink,
  secondText,
  fourthText,
  thirdLink,
  thirdText,
}) => {
  return (
    <p className="w-full flex items-center gap-2">
      {firstLink && (
        <>
          {/* <img src={Chevron} alt="" /> */}
          <Link to={firstLink} state={firstLinkState}>
            <span
              className={
                !secondText
                  ? "font-semibold text-[14px] text-[#1E3A8A]"
                  : "font-normal text-[14px] text-[#4B5563]"
              }
            >
              {" "}
              {firstText}
            </span>
          </Link>
        </>
      )}
      {secondText && (
        <>
          <img src={Chevron} alt="" className="mt-1" />
          <Link to={secondLink}>
            <span
              className={
                !thirdText
                  ? "font-semibold text-[14px] text-[#1E3A8A]"
                  : "font-normal text-[14px] text-[#4B5563]"
              }
              style={{ height: "100px" }}
            >
              {secondText}
            </span>
          </Link>
        </>
      )}
      {thirdText && (
        <>
          <img src={Chevron} alt="" className="mt-1" />
          <Link to={thirdLink}>
            <span
              className={
                !fourthText
                  ? "font-semibold text-[14px] text-[#1E3A8A]"
                  : "font-normal text-[14px] text-[#4B5563]"
              }
            >
              {thirdText}
            </span>
          </Link>
        </>
      )}
      {fourthText && (
        <>
          <img src={Chevron} alt="" className="mt-1" />
          {/* <Link to={thirdLink}>
          </Link> */}
          <span className="font-semibold text-[14px] text-[#1E3A8A] mt-[2px]">
            {fourthText}
          </span>
        </>
      )}
    </p>
  );
};

export default BreadCrum;
